"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var FlyingLetter_1 = require("./components/FlyingLetter/FlyingLetter");
var LogoLoader_1 = require("./components/LogoLoader/LogoLoader");
var Loader = function (_a) {
    var data = _a.data, testId = _a.testId;
    var styles = data.styles, progress = data.progress, text = data.text, customLoader = data.customLoader;
    var barWidth = progress !== undefined ? progress : 22.5;
    return (React.createElement("div", { "data-test-id": testId, className: styles.progressContainer },
        React.createElement("div", { className: styles.attLogoContainer },
            (!customLoader) && React.createElement("div", { className: styles.attLogoWrapper },
                React.createElement(LogoLoader_1.default, null)),
            (customLoader) && React.createElement("div", { className: styles.attLogoWrapper },
                React.createElement("div", { className: styles.attLogoNew })),
            (!customLoader) && React.createElement("div", { className: styles.attFlyingWrapper },
                React.createElement(FlyingLetter_1.default, null))),
        (text) && React.createElement("div", { className: customLoader ? styles.baseTextCustomLoader : styles.baseText }, text),
        (!customLoader) && React.createElement("div", { className: styles.progressBarContainer },
            progress !== undefined && React.createElement("span", { className: styles.percents },
                progress,
                "%"),
            React.createElement("div", { className: styles.progress },
                React.createElement("div", { style: { width: barWidth + "%" }, className: styles.bar })))));
};
exports.default = Loader;
//# sourceMappingURL=Loader.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Loader/Loader.js
// module id = 1166
// module chunks = 8